var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentError)?_c('ul',{staticClass:"errors"},[_c('li',[_vm._v(" "+_vm._s(_vm.currentError.message)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }